import PropTypes from 'prop-types';
import moment from 'moment';
import mt from 'moment-timezone';

const Time = ({ time, format, timezone = null }) => {
  const userTimeZone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  return mt(moment.utc(new Date(time).toUTCString()))
    .tz(userTimeZone)
    .format(format);
};

Time.propTypes = {
  time: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  timezone: PropTypes.string
};

export { Time };
